import intl from "react-intl-universal";
import { BaasStablesNetworkBadge } from "./BaasStablesNetworkBadge";

const ContextRow = ({ label, value }) => (
  <div className="flex flex-col gap-0.5 sm:flex-row sm:items-center sm:justify-between">
    <span className="text-xs text-gray-500 dark:text-gray-400">{label}</span>
    <span className="text-sm font-medium text-brand-dark dark:text-gray-100 sm:text-right">
      {value || "—"}
    </span>
  </div>
);

export const BaasStablesWalletContextCard = ({ wallet }) => {
  if (!wallet) return null;

  return (
    <section className="app-card p-4 sm:p-5">
      <p className="text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400">
        {intl.get("baas.stables.operation.context.title")}
      </p>
      <div className="mt-3 grid gap-4 sm:grid-cols-2">
        <div className="space-y-2 rounded-xl border border-gray-100 p-3 dark:border-brand-dark-border">
          <p className="text-xs font-semibold text-brand-dark dark:text-gray-100">
            {intl.get("baas.stables.operation.context.entity")}
          </p>
          <ContextRow
            label={intl.get("baas.stablesWallet.columns.entity")}
            value={wallet.entityName}
          />
          <ContextRow
            label={intl.get("baas.stablesWallet.detail.entityId")}
            value={wallet.entityId}
          />
        </div>
        <div className="space-y-2 rounded-xl border border-gray-100 p-3 dark:border-brand-dark-border">
          <p className="text-xs font-semibold text-brand-dark dark:text-gray-100">
            {intl.get("baas.stables.operation.context.account")}
          </p>
          <ContextRow
            label={intl.get("baas.stablesWallet.detail.accountAlias")}
            value={wallet.accountAlias}
          />
          <ContextRow
            label={intl.get("baas.stablesWallet.detail.accountNumber")}
            value={wallet.accountNumber}
          />
          <ContextRow
            label={intl.get("baas.stablesWallet.columns.network")}
            value={<BaasStablesNetworkBadge network={wallet.network} />}
          />
        </div>
      </div>
    </section>
  );
};
